// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/**
 * Created by Inzamam Janjua on 18/05/2023.
 */
.verfy-wrap {
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  background: url('mesh-gradient.d2e368c6b9d92bb7.png') center center;
  background-size: cover;
  flex-direction: column;
  padding: 20px;
  box-sizing: border-box;
}
.verfy-wrap .verfy-screen-logo {
  margin-top: 40px;
  margin-bottom: 20px;
}
.verfy-wrap .verfy-box {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(12px);
  border-radius: 20px;
  padding: 40px 60px;
  text-align: center;
  width: 600px;
  margin-top: 170px;
  max-width: 100%;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  transition: margin-top 0.4s cubic-bezier(0.16, 1, 0.3, 1), box-shadow 0.4s;
  box-sizing: border-box;
  /* PDF Viewer Container */
  /* Signature Sidebar Panel */
  /* Receipt card styling */
  /* Success / Error icon containers */
}
.verfy-wrap .verfy-box.wide-box {
  width: 95%;
  max-width: 1400px;
  padding: 30px 40px;
  margin-top: 50px;
}
.verfy-wrap .verfy-box h2 {
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 34px;
  color: #1f2937;
  margin-top: 0;
  margin-bottom: 12px;
}
.verfy-wrap .verfy-box p.subtitle {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #4b5563;
  margin-bottom: 24px;
}
.verfy-wrap .verfy-box .Verify-dob {
  border: 1px solid #d1d5db;
  border-radius: 8px;
  background: #fff;
  display: flex;
  align-items: center;
  gap: 15px;
  margin-top: 30px;
  padding: 0 16px;
  height: 52px;
  position: relative;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.verfy-wrap .verfy-box .Verify-dob:focus-within {
  border-color: #2D388B;
  box-shadow: 0 0 0 3px rgba(45, 56, 139, 0.15);
}
.verfy-wrap .verfy-box .Verify-dob img {
  width: 20px;
  opacity: 0.6;
}
.verfy-wrap .verfy-box .Verify-dob .input-mask-field {
  border: none;
  outline: none;
  width: 100%;
  font-size: 16px;
}
.verfy-wrap .verfy-box .pdf-container {
  background-color: #f3f4f6;
  border: 1px solid #e5e7eb;
  height: 750px;
  position: relative;
}
.verfy-wrap .verfy-box .pdf-container .pdf-viewer-scroll {
  cursor: grab;
}
.verfy-wrap .verfy-box .sign-controls-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  min-height: 400px;
  background: #f9fafb;
}
.verfy-wrap .verfy-box .receipt-card {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.01);
}
.verfy-wrap .verfy-box .status-icon-container {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px auto;
}
.verfy-wrap .verfy-box .status-icon-container.success-bg {
  background: #ecfdf5;
}
.verfy-wrap .verfy-box .status-icon-container.error-bg {
  background: #fef2f2;
}

.verify-agency-logo {
  max-height: 80px;
  max-width: 300px;
  object-fit: contain;
}

.powered-wrapper {
  margin-top: 40px;
  margin-bottom: 20px;
  display: flex;
  gap: 6px;
  flex-direction: column;
  align-items: center;
}
.powered-wrapper span {
  font-size: 11px;
  font-weight: 600;
  line-height: 14px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: #4b5563;
}
.powered-wrapper .image-wrapper {
  width: 140px;
}
.powered-wrapper .image-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* Animations */
.fade-in {
  animation: fadeIn 0.4s ease-out forwards;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
/* Custom Overrides for Calendar/PrimeNG Inputs */
::ng-deep .disable-calendar .p-calendar {
  width: 100%;
}
::ng-deep .disable-calendar .p-inputtext {
  border: none !important;
  box-shadow: none !important;
  padding: 0 !important;
  height: 48px;
  font-size: 16px;
  width: 100%;
}
::ng-deep .p-checkbox .p-checkbox-box {
  border-radius: 4px;
  border-color: #d1d5db;
}
::ng-deep .p-checkbox .p-checkbox-box.p-highlight {
  background: #2D388B;
  border-color: #2D388B;
}

@media (max-width: 991px), (pointer: coarse) {
  .verfy-wrap .verfy-box {
    width: 100%;
    padding: 30px 20px;
    margin-top: 10px;
  }
  .verfy-wrap .verfy-box.wide-box {
    width: 100%;
    padding: 24px 16px;
  }
  .verfy-wrap .verfy-box .pdf-container {
    height: 400px;
  }
  .verfy-wrap .verfy-box .sign-controls-card {
    min-height: auto;
    margin-top: 20px;
  }
}
/* Caveat handwriting font for typed signatures. CDN-first with a self-hosted fallback: the
   browser tries the CDN, and if that request fails (offline, blocked on a locked-down clinical
   network, or a stale URL) it uses the bundled copy — so the signature always renders in the
   font the signer saw, and the WYSIWYG guarantee holds everywhere.
   Caveat is licensed under the SIL Open Font License 1.1 — see src/assets/fonts/OFL.txt. */
@font-face {
  font-family: "Caveat";
  font-style: normal;
  font-weight: 700;
  /* 'block' (not 'swap') so the typed signature never renders in a fallback font and then visibly
     swaps to Caveat — during the brief load it stays hidden instead of flashing the wrong font.
     Combined with the ngOnInit preload, Caveat is loaded well before the Type step, so there is no
     visible delay in practice. */
  font-display: block;
  src: url("https://cdn.jsdelivr.net/npm/@fontsource/caveat/files/caveat-latin-700-normal.woff2") format("woff2"), url("/assets/fonts/caveat-700.woff2") format("woff2");
}
.sig-tabs {
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 2px;
  display: flex;
  gap: 4px;
}

.sig-tab-btn {
  flex: 1;
  background: transparent;
  border: none;
  padding: 6px 12px;
  font-size: 13px;
  font-weight: 600;
  color: #4b5563;
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.2s ease;
  outline: none;
}
.sig-tab-btn:hover {
  color: #1f2937;
  background: rgba(255, 255, 255, 0.5);
}
.sig-tab-btn.active {
  background: #ffffff;
  color: #2d388b;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
.sig-tab-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.sig-panel {
  border: 1px solid #e5e7eb;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.05);
}

.sig-canvas {
  touch-action: none; /* prevent browser scrolling while drawing */
  border: 1px dashed #d1d5db;
  border-radius: 6px;
  transition: border-color 0.2s;
  display: block;
}
.sig-canvas:hover {
  border-color: #9ca3af;
}

.type-sig-preview {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed #d1d5db;
  border-radius: 6px;
  background-color: #f9fafb;
  color: #000000; /* typed signature ink is black (matches drawn signatures) */
  font-weight: bold;
}

/* Unified accent ink (io navy) — replaces the stray indigo/purple accents on the
   signing page so labels, badges and the typed-signature preview match the theme. */
.io-ink {
  color: #2D388B;
}

.io-ink-soft-bg {
  background: #eef1fb;
}

::ng-deep .esign-green-btn {
  background: #6ACE6A !important;
  border: 1px solid #6ACE6A !important;
  color: #ffffff !important;
  transition: background-color 0.2s, border-color 0.2s;
}
::ng-deep .esign-green-btn:hover:not(:disabled) {
  background: #7AEC7A !important;
  border-color: #7AEC7A !important;
}
::ng-deep .esign-green-btn:focus:not(:disabled) {
  background: #5CB85C !important;
  border-color: #5CB85C !important;
}
::ng-deep .esign-green-btn:active:not(:disabled) {
  background: #5CB85C !important;
  border-color: #5CB85C !important;
}
::ng-deep .esign-green-btn:disabled {
  opacity: 0.6 !important;
  background: #6ACE6A !important;
  border-color: #6ACE6A !important;
  cursor: not-allowed !important;
}

/* PDF.js Annotation Layer Styles (Read-only for patient) */
::ng-deep {
  /* Hide all widgets in the annotation layer completely to prevent duplicate text overlay, but keep them in layout tree for auto-placement */
  /* Fields this signer fills in (IOHB-1779): shown and editable over the page. The opaque background
     covers the page's own rendering of the field underneath, so a value never shows twice. */
  /* The field the signer is on (IOHB-1884), outlined in the same yellow as the active signature box */
  /* Guide text in an empty field the signer fills in (IOHB-1886), in the colour of "Sign Here" */
}
::ng-deep .annotationLayer {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 1;
  line-height: 1;
  pointer-events: none !important; /* Patient cannot interact/change values */
}
::ng-deep .annotationLayer > * {
  position: absolute;
  pointer-events: none !important;
  box-sizing: border-box;
}
::ng-deep .annotationLayer .linkAnnotation > a {
  position: absolute;
  font-size: 1em;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none !important;
}
::ng-deep .annotationLayer input,
::ng-deep .annotationLayer textarea,
::ng-deep .annotationLayer select,
::ng-deep .annotationLayer button,
::ng-deep .annotationLayer .buttonWidgetAnnotation,
::ng-deep .annotationLayer .textWidgetAnnotation,
::ng-deep .annotationLayer .choiceWidgetAnnotation {
  opacity: 0 !important;
  pointer-events: none !important;
  -webkit-user-select: none !important;
          user-select: none !important;
}
::ng-deep .annotationLayer section.esign-fill-field {
  opacity: 1 !important;
  pointer-events: auto !important;
}
::ng-deep .annotationLayer section.esign-fill-field input,
::ng-deep .annotationLayer section.esign-fill-field textarea,
::ng-deep .annotationLayer section.esign-fill-field select {
  opacity: 1 !important;
  pointer-events: auto !important;
  -webkit-user-select: text !important;
          user-select: text !important;
  background-color: #fffbeb !important;
  border: 1px solid #f59e0b !important;
  color: #111827 !important;
  box-sizing: border-box;
}
::ng-deep .annotationLayer section.esign-fill-field.esign-fill-required input,
::ng-deep .annotationLayer section.esign-fill-field.esign-fill-required textarea,
::ng-deep .annotationLayer section.esign-fill-field.esign-fill-required select {
  border-color: #dc2626 !important;
}
::ng-deep .annotationLayer section.esign-fill-field.esign-fill-active input,
::ng-deep .annotationLayer section.esign-fill-field.esign-fill-active textarea,
::ng-deep .annotationLayer section.esign-fill-field.esign-fill-active select {
  outline: 3px solid #fbc02d !important;
  outline-offset: 1px;
}
::ng-deep .annotationLayer section.esign-fill-field input[type=checkbox],
::ng-deep .annotationLayer section.esign-fill-field input[type=radio] {
  appearance: auto !important;
  accent-color: #16a34a;
  background-color: #ffffff !important;
}
::ng-deep .annotationLayer section.esign-fill-field input::placeholder,
::ng-deep .annotationLayer section.esign-fill-field textarea::placeholder {
  color: #c27e00;
  opacity: 1;
}

/* On a phone the page is drawn at about half its size, so a form's checkbox or radio button is 5-6px: hard to hit with a
   finger and hard to see. Draw it at 16px, centred on the same spot; what is saved is unchanged (IOHB-2000 QA). All three
   rules are for phones only: on a desktop the boxes look and work as before (IOHB-2118). */
@media (max-width: 991px), (pointer: coarse) {
  ::ng-deep {
    /* A ticked box or a chosen option stands out at a glance, after the signer has moved on to other fields. */
    /* pdf.js draws its own cross (checkbox) or dot (radio) on a ticked box with ::before/::after. Over the browser's own
       green tick that showed a tick and a cross at once, so only the browser's mark is kept. */
  }
  ::ng-deep .annotationLayer section.esign-fill-field input[type=checkbox],
  ::ng-deep .annotationLayer section.esign-fill-field input[type=radio] {
    position: absolute !important;
    left: 50% !important;
    top: 50% !important;
    width: 16px !important;
    height: 16px !important;
    margin: 0 !important;
    transform: translate(-50%, -50%);
  }
  ::ng-deep .annotationLayer section.esign-fill-field input[type=checkbox]:checked,
  ::ng-deep .annotationLayer section.esign-fill-field input[type=radio]:checked {
    box-shadow: 0 0 0 3px rgba(22, 163, 74, 0.45) !important;
  }
  ::ng-deep .annotationLayer section.esign-fill-field input[type=checkbox]::before,
  ::ng-deep .annotationLayer section.esign-fill-field input[type=checkbox]::after,
  ::ng-deep .annotationLayer section.esign-fill-field input[type=radio]::before,
  ::ng-deep .annotationLayer section.esign-fill-field input[type=radio]::after {
    content: none !important;
    display: none !important;
  }
}
/* Label above a field the signer fills in (IOHB-1886), sized and coloured like the signature labels. It sits in a row as
   wide as the page: the gap before it lines it up with its field and gives way where the page ends first, so a long label
   near the right edge moves left instead of running off the page (and one wider than the page is cut short). */
.esign-fill-tag-row {
  position: absolute;
  left: 0;
  right: 0;
  z-index: 150;
  display: flex;
  pointer-events: none;
}

.esign-fill-tag-gap {
  flex: 0 1 auto;
  min-width: 0;
}

.esign-fill-tag {
  flex: none;
  box-sizing: border-box;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #fff;
  font-size: 9px;
  font-weight: bold;
  line-height: normal;
  padding: 1px 4px;
  border-radius: 3px;
  white-space: nowrap;
}

.pdf-zoom-controls {
  position: absolute;
  right: 28px;
  bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  z-index: 1000;
}
.pdf-zoom-controls button {
  width: 38px !important;
  height: 38px !important;
  border-radius: 10px !important;
  background: #ffffff !important;
  border: 1px solid #e5e7eb !important;
  color: #2D388B !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  cursor: pointer;
  padding: 0 !important;
  transition: transform 0.1s ease, background-color 0.2s;
}
.pdf-zoom-controls button:hover:not(:disabled) {
  background-color: #f9fafb !important;
  transform: scale(1.05);
}
.pdf-zoom-controls button:active:not(:disabled) {
  transform: scale(0.95);
}
.pdf-zoom-controls button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.pdf-zoom-controls button i {
  font-size: 14px !important;
  font-weight: 700 !important;
}

.pdf-pages-container {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  min-width: 100%;
  transition: transform 0.1s ease-out;
  will-change: transform;
}

/* Electronic Signature Consent Modal & Blur Styling */
.consent-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(15, 23, 42, 0.4);
  backdrop-filter: blur(4px);
  z-index: 2000;
  border-radius: 8px;
  padding: 1rem;
  overflow-y: auto;
}

.consent-modal-card {
  max-width: 500px;
  width: 100%;
  max-height: calc(100vh - 2rem);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: scaleUp 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
}
.consent-modal-card > *:not(.consent-disclosure-scroll) {
  flex: 0 0 auto;
}

.consent-disclosure-scroll {
  flex: 1 1 auto;
  min-height: 110px;
  display: flex;
  flex-direction: column;
}
.consent-disclosure-scroll .disclosure-box {
  max-height: none !important;
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
}

.consent-modal-footer {
  flex: 0 0 auto;
  border-top: 1px solid #e2e8f0;
  padding-top: 0.85rem;
  margin-top: 0.25rem;
}

@media (max-height: 800px) {
  .consent-modal-card .consent-modal-subline {
    display: none;
  }
  .consent-modal-card .consent-modal-header {
    margin-bottom: 0.75rem !important;
  }
}
@media (max-height: 680px) {
  .consent-modal-card {
    padding: 1.1rem !important;
  }
  .consent-modal-card .consent-modal-logo {
    display: none;
  }
  .consent-modal-card .consent-modal-title {
    font-size: 1rem;
  }
  .consent-modal-card .consent-modal-header {
    margin-bottom: 0.5rem !important;
  }
  .consent-modal-footer {
    padding-top: 0.6rem;
  }
  .consent-modal-footer .field-checkbox {
    padding: 0.6rem !important;
    margin-bottom: 0.6rem !important;
  }
}
.disclosure-box {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  overflow-y: auto;
  overscroll-behavior: contain;
  /* subtle inset shadow at the bottom edge hints there is more to read (scroll affordance) */
  box-shadow: inset 0 -10px 8px -8px rgba(15, 23, 42, 0.12);
}
.disclosure-box::-webkit-scrollbar {
  width: 10px;
}
.disclosure-box::-webkit-scrollbar-track {
  background: #e6e9f4;
  border-radius: 5px;
}
.disclosure-box::-webkit-scrollbar-thumb {
  background-color: #2d388b;
  border-radius: 5px;
  border: 2px solid #e6e9f4;
}
.disclosure-box::-webkit-scrollbar-thumb:hover {
  background-color: #242f74;
}

.blurred-console {
  filter: blur(5px);
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
}

/* Full Width mobile sign console optimization */
@media (max-width: 991px), (pointer: coarse) {
  .verfy-wrap {
    padding: 0px !important;
  }
  .verfy-wrap .verfy-box {
    margin-top: 0px !important;
    border-radius: 0px !important;
    border: none !important;
    box-shadow: none !important;
  }
  .verfy-wrap .verfy-box.wide-box {
    width: 100% !important;
    max-width: 100% !important;
    padding: 12px 8px !important;
  }
  .pdf-viewer-scroll {
    padding: 4px !important;
  }
  .grid {
    margin-left: -4px !important;
    margin-right: -4px !important;
    margin-top: 0px !important;
  }
  .grid > [class*=col-] {
    padding: 4px !important;
  }
}
.sig-panel-wrapper .redo-hover-overlay {
  transition: opacity 0.25s ease-in-out;
}
.sig-panel-wrapper:hover .redo-hover-overlay {
  opacity: 1 !important;
  pointer-events: auto !important;
}
@media (max-width: 991px), (pointer: coarse) {
  .sig-panel-wrapper .redo-hover-overlay {
    opacity: 1 !important;
    pointer-events: auto !important;
    background: transparent !important;
    backdrop-filter: none !important;
    justify-content: flex-end !important;
    align-items: flex-start !important;
    padding: 6px !important;
  }
  .sig-panel-wrapper .redo-hover-overlay button {
    padding: 4px 8px !important;
    font-size: 11px !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
  }
}

@media (max-width: 991px), (pointer: coarse) {
  .verfy-wrap {
    padding: 0 !important;
    background: #dfe3ee !important;
    min-height: 100vh;
    min-height: 100dvh;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
  .verfy-wrap .verfy-box {
    margin: 0 !important;
    padding: 0 !important;
    border-radius: 0 !important;
    width: 100% !important;
    max-width: 100% !important;
    min-height: 100vh;
    min-height: 100dvh;
    display: flex;
    flex-direction: column;
    background: #dfe3ee !important;
    box-shadow: none !important;
  }
  .verfy-wrap .verfy-box .pdf-container {
    flex: 1 1 auto;
    height: calc(100vh - 220px) !important;
    border-radius: 0 !important;
    border: none !important;
  }
  .mobile-topbar {
    flex: 0 0 auto;
    height: 52px;
    box-sizing: border-box;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    background: #ffffff;
  }
  .mobile-topbar .brand-dot {
    background: #6ACE6A !important;
    font-weight: bold;
  }
  .mobile-bottom-bar {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
    box-shadow: 0 -6px 22px rgba(0, 0, 0, 0.1);
    border-top: 1px solid #e5e7eb;
    padding-bottom: calc(12px + env(safe-area-inset-bottom)) !important;
  }
  .mobile-bottom-bar .btn-primary {
    transition: background 0.15s, opacity 0.15s;
  }
  .mobile-bottom-bar .btn-primary:disabled {
    opacity: 0.45 !important;
    cursor: not-allowed !important;
  }
  .mobile-bottom-sheet {
    transform: translateY(110%);
    transition: transform 0.3s cubic-bezier(0.34, 1.3, 0.64, 1);
    box-sizing: border-box;
    border-top: 1px solid #cbd5e1;
    padding-bottom: calc(16px + env(safe-area-inset-bottom)) !important;
    max-height: calc(100vh - 56px);
    overflow-y: auto;
    overscroll-behavior: contain;
  }
  .mobile-bottom-sheet.show-sheet {
    transform: translateY(0);
  }
  .mobile-bottom-sheet .sheet-actions button {
    height: 44px !important;
    border-radius: 11px !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .mobile-bottom-sheet .sheet-actions .btn-clear, .mobile-bottom-sheet .sheet-actions .btn-close {
    border: 1px solid #cbd5e1 !important;
    background: #ffffff !important;
    color: #4b5563 !important;
    font-weight: 600;
  }
  .mobile-bottom-sheet .sheet-actions .btn-clear:hover, .mobile-bottom-sheet .sheet-actions .btn-close:hover {
    background: #f9fafb !important;
  }
  .mobile-bottom-sheet .sheet-actions .btn-apply {
    background: #2D388B !important;
    color: #ffffff !important;
  }
  .mobile-bottom-sheet .sheet-actions .btn-apply:disabled {
    opacity: 0.45 !important;
    cursor: not-allowed !important;
  }
  /* IOHB-1632 feedback: on touch devices the bottom sheet covers the PDF's lower
     edge, clipping the vertical zoom stack to just "+". Pin it to the top-right. */
  .pdf-zoom-controls {
    top: 12px !important;
    right: 12px !important;
    bottom: auto !important;
  }
  /* IOHB-1632 feedback: larger type-signature input on phones/tablets. */
  .mobile-type-sig-input {
    font-size: 20px !important;
    height: 50px !important;
  }
  .pdf-viewer-scroll {
    padding: 0 0 var(--sheet-pad, calc(120px + env(safe-area-inset-bottom))) 0 !important;
  }
}
/* IOHB-1632: guide the signer on mobile — pulse the active field + a floating tag.
   Scoped to <=991px so the desktop signing console is unaffected. */
@media (max-width: 991px), (pointer: coarse) {
  .active-sig-box {
    animation: sigPulse 1.25s ease-in-out infinite;
  }
  .sig-guide-tag {
    position: absolute;
    top: -34px;
    left: 0;
    background: #1e38a9;
    color: #fff;
    font-size: 9.5px;
    font-weight: 700;
    padding: 2px 8px;
    border-radius: 12px;
    white-space: nowrap;
    box-shadow: 0 3px 8px rgba(30, 56, 169, 0.35);
    animation: sigBob 1s ease-in-out infinite;
    z-index: 160;
  }
}
@keyframes sigPulse {
  0%, 100% {
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15), 0 0 0 0 rgba(251, 192, 45, 0);
  }
  50% {
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15), 0 0 0 5px rgba(251, 192, 45, 0.35);
  }
}
@keyframes sigBob {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-3px);
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
